var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispatcherCallStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C7EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75859 14.0875L9.93008 13.1512C10.1891 13.0516 10.4879 13.1113 10.6473 13.3305L11.5238 14.4063C12.9184 13.7289 14.034 12.6133 14.7113 11.2188L13.6355 10.3422C13.4164 10.1828 13.3566 9.88398 13.4562 9.625L14.3926 7.45352C14.5121 7.19453 14.8109 7.03516 15.0898 7.09492L17.102 7.57305C17.4008 7.63281 17.5801 7.87188 17.5801 8.1707C17.5801 13.191 13.4961 17.2949 8.47578 17.2949C8.17695 17.2949 7.93789 17.0957 7.87813 16.7969L7.4 14.8047C7.34023 14.5059 7.49961 14.207 7.75859 14.0875Z",
    fill: "#005585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatcherCallStarted);
export default __webpack_public_path__ + "static/media/DISPATCHER_CALL_STARTED.333a7896330e28f6941ef4a47f4598d4.svg";
export { ForwardRef as ReactComponent };